import React, { useState } from 'react'
import styles from './Lamination.module.css'
import {
  FsBlack,
  FsAnthraciteGrey,
  FsSlateGrey,
  FsQuartzGrey,
  FsBasaltgrey,
  FsSilverGrey,
  FsUmbra,
  FsTrafficWhite,
  StdGoldenOak,
  StdWalnut,
  StdBogOak,
  StdAnthraciteGrey,
  NsAnthraciteGreySilk,
  NsEarlPlatinum,
  NsCrownPlatinum,
  NsBlackBrown,
  NsBrown,
  NsSienaNoce,
  NsWinchester,
  NsWhite,
  NsSlateGrey,
  NsSlateGreySmooth,
  NsQuartzGrey,
  NsBasaltGrey,
  NsBasaltGreySmooth,
  NsSilverGrey,
  NsSilverGreySmooth,
  NsLightGrey,
  NsAgateGrey,
  NsQuartzPlatinum,
  NsBrushedAluminium,
  NsMacore,
  NsMahogany,
  NsSienaRosso,
  NsRusticOak,
  NsStripedDouglasFir,
  NsDouglasFir,
  NsShogunAd,
  NsShogunAf,
  NsMountainPine,
  NsOregonIii,
  NsLightOak,
  NsSteelBlue,
  NsBrilliantBlue,
  NsCobaltBlue,
  NsMonumentGreen,
  NsMossGreen,
  NsFirGreen,
  NsWineRed,
  NsBrownRed,
  NsRubyRed,
  NsPapyrusWhite,
  NsZincYellow,
  NsLightIvory,
  NsSheffieldOakGrey,
  NsSheffieldOakLight,
  NsCreamWhite,
  SpAnthraciteUltramatt,
  SpWindowGreyUltramatt,
  SpUmbraUltramatt,
  SpGraphiteBlackUltramatt,
  SpFirGreenUltramatt,
  SpWhiteUltramatt,
  SpPureWhiteUltramatt,
  SpSepiaBrownUltramatt,
} from '../../../Assets/Images/WindowsPage/Lamination/Index'

const groups = [
  {
    title: "FineStrukture",
    colors: [
      { name: "Black", hex: "#282727", img: FsBlack },
      { name: "Anthracite Grey", hex: "#3C4549", img: FsAnthraciteGrey },
      { name: "Slate Grey", hex: "#475050", img: FsSlateGrey },
      { name: "Quartz Grey", hex: "#5E5F57", img: FsQuartzGrey },
      { name: "Basaltgrey", hex: "#4D5554", img: FsBasaltgrey },
      { name: "Silver Grey", hex: "#9CA9B0", img: FsSilverGrey },
      { name: "Umbra", hex: "#4A4132", img: FsUmbra },
      { name: "Traffic White", hex: "#E7E9E1", img: FsTrafficWhite },
    ],
  },
  {
    title: "Standard colors",
    colors: [
      { name: "Golden Oak", hex: "#854E15", img: StdGoldenOak },
      { name: "Walnut", hex: "#623A2C", img: StdWalnut },
      { name: "Bog Oak", hex: "#4C3625", img: StdBogOak },
      { name: "Anthracite Grey", hex: "#2C2D32", img: StdAnthraciteGrey },
    ],
  },
  {
    title: "Non-standard colors",
    colors: [
      { name: "Anthracite Grey Silk", hex: "#31343D", img: NsAnthraciteGreySilk },
      { name: "Earl Platinum", hex: "#342F31", img: NsEarlPlatinum },
      { name: "Crown Platinum", hex: "#565960", img: NsCrownPlatinum },
      { name: "Black Brown", hex: "#1A1716", img: NsBlackBrown },
      { name: "Brown", hex: "#2B1D16", img: NsBrown },
      { name: "Siena Noce", hex: "#4A3731", img: NsSienaNoce },
      { name: "Winchester", hex: "#875B3C", img: NsWinchester },
      { name: "White", hex: "#EEEEE7", img: NsWhite },
      { name: "Slate Grey", hex: "#55545B", img: NsSlateGrey },
      { name: "Slate Grey Smooth", hex: "#54595F", img: NsSlateGreySmooth },
      { name: "Quartz Grey", hex: "#4A463E", img: NsQuartzGrey },
      { name: "Basalt Grey", hex: "#474A48", img: NsBasaltGrey },
      { name: "Basalt Grey Smooth", hex: "#5E605F", img: NsBasaltGreySmooth },
      { name: "Silver Grey", hex: "#7B837D", img: NsSilverGrey },
      { name: "Silver Grey Smooth", hex: "#8A9595", img: NsSilverGreySmooth },
      { name: "Light Grey", hex: "#C1C3C0", img: NsLightGrey },
      { name: "Agate Grey", hex: "#707A75", img: NsAgateGrey },
      { name: "Quartz Platinum", hex: "#636461", img: NsQuartzPlatinum },
      { name: "Brushed Aluminium", hex: "#B0B5B8", img: NsBrushedAluminium },
      { name: "Macore", hex: "#2A160F", img: NsMacore },
      { name: "Mahogany", hex: "#2E170A", img: NsMahogany },
      { name: "Siena Rosso", hex: "#653118", img: NsSienaRosso },
      { name: "Rustic Oak", hex: "#412E22", img: NsRusticOak },
      { name: "Striped Douglas Fir", hex: "#864E27", img: NsStripedDouglasFir },
      { name: "Douglas Fir", hex: "#945C25", img: NsDouglasFir },
      { name: "Shogun AD", hex: "#90562A", img: NsShogunAd },
      { name: "Shogun AF", hex: "#B56A33", img: NsShogunAf },
      { name: "Mountain Pine", hex: "#BF8A5D", img: NsMountainPine },
      { name: "Oregon III", hex: "#D58A3E", img: NsOregonIii },
      { name: "Light Oak", hex: "#CA9F60", img: NsLightOak },
      { name: "Steel Blue", hex: "#32424F", img: NsSteelBlue },
      { name: "Brilliant Blue", hex: "#045987", img: NsBrilliantBlue },
      { name: "Cobalt Blue", hex: "#213A60", img: NsCobaltBlue },
      { name: "Monument Green", hex: "#2F3837", img: NsMonumentGreen },
      { name: "Moss Green", hex: "#022F1B", img: NsMossGreen },
      { name: "Fir Green", hex: "#222E24", img: NsFirGreen },
      { name: "Wine Red", hex: "#5A2027", img: NsWineRed },
      { name: "Brown Red", hex: "#550F16", img: NsBrownRed },
      { name: "Ruby Red", hex: "#861409", img: NsRubyRed },
      { name: "Papyrus White", hex: "#CCCCC8", img: NsPapyrusWhite },
      { name: "Zinc Yellow", hex: "#FFE019", img: NsZincYellow },
      { name: "Light Ivory", hex: "#E2D7B7", img: NsLightIvory },
      { name: "Sheffield Oak Grey", hex: "#8D8379", img: NsSheffieldOakGrey },
      { name: "Sheffield Oak Light", hex: "#BCAD9B", img: NsSheffieldOakLight },
      { name: "Cream White", hex: "#DED9CA", img: NsCreamWhite },
    ],
  },
  {
    title: "Spectral",
    colors: [
      { name: "Anthracite Ultramatt", hex: "#3C3F46", img: SpAnthraciteUltramatt },
      { name: "Window Grey Ultramatt", hex: "#707981", img: SpWindowGreyUltramatt },
      { name: "Umbra Ultramatt", hex: "#5C5148", img: SpUmbraUltramatt },
      { name: "Graphite Black Ultramatt", hex: "#242323", img: SpGraphiteBlackUltramatt },
      { name: "Fir Green Ultramatt", hex: "#25322C", img: SpFirGreenUltramatt },
      { name: "White Ultramatt", hex: "#F3F3E8", img: SpWhiteUltramatt },
      { name: "Pure White Ultramatt", hex: "#E7E0D7", img: SpPureWhiteUltramatt },
      { name: "Sepia Brown Ultramatt", hex: "#342B22", img: SpSepiaBrownUltramatt },
    ],
  },
];

const Lamination = () => {
  const [active, setActive] = useState(groups[0].colors[0])

  return (
    <section className={styles.wrap} id="lamination">
      <div className={`customContainer ${styles.container}`}>

        {/* TITLE */}
        <div className={styles.head}>
          <div className={styles.titles}>
            <hr className={styles.titles_line} />
            <h2 className={styles.titles_title}>Colors of Lamination</h2>
            <hr className={styles.titles_line} />
          </div>

          <p className={styles.desc}>
            Our windows are made from certified European materials that ensure long-lasting durability and comfort.
            Every detail, from the profile to the glazing, is designed to optimize performance and aesthetics.
          </p>
        </div>

        <div className={styles.content}>

          {/* LEFT — CURRENT WINDOW */}
          <div className={styles.preview}>
            <img src={active.img} alt={active.name} className={styles.preview_img} />

            {/* shown instead of .current while the bar is pinned on narrow screens */}
            <div className={styles.preview_meta}>
              <span className={styles.current_label}>Current color</span>
              <span className={styles.current_name}>{active.name}</span>
            </div>
          </div>

          {/* RIGHT — COLOR PICKER */}
          <div className={styles.colors}>

            <div className={styles.current}>
              <span className={styles.current_label}>Current color</span>
              <span className={styles.current_name}>{active.name}</span>
            </div>

            {groups.map((group) => (
              <div className={styles.group} key={group.title}>
                <h3 className={styles.group_title}>{group.title}</h3>

                <div className={styles.swatches}>
                  {group.colors.map((color) => (
                    <button
                      type="button"
                      key={color.name + color.hex}
                      onClick={() => setActive(color)}
                      style={{ background: color.hex }}
                      className={`${styles.swatch} ${active === color ? styles.swatch_active : ''}`}
                    >
                      <span className={styles.tooltip}>{color.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  )
}

export default Lamination
